function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.5 22.8h-17c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h17c.4 0 .8.3.8.8s-.4.8-.8.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 18.2c-.2 0-.4-.1-.5-.2L4.5 4c-.3-.3-.3-.7 0-1 .3-.3.8-.3 1.1 0l14 14c.3.3.3.8 0 1.1-.2.1-.4.1-.6.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 14.5c-.4 0-.8-.3-.8-.8V3.5c0-.4.3-.8.8-.8h10.3c.4 0 .8.3.8.8s-.3.8-.8.8H5.8v9.5c0 .4-.4.7-.8.7z"
})));